import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "examples" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Basic"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "example",
    id: "exampleBasic"
  }),
  /*#__PURE__*/_createElementVNode("pre", null, [
    /*#__PURE__*/_createTextVNode("        "),
    /*#__PURE__*/_createElementVNode("code", { class: "language-javascript" }, "\n          new FPMoney({\n            container: document.querySelector('#example')\n          })\n        "),
    /*#__PURE__*/_createTextVNode("\n      ")
  ])
], -1)
const _hoisted_3 = { class: "section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Currency Selection", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "example",
  id: "exampleSelection"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("        "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-javascript" }, "\n          new FPMoney({\n            container: document.querySelector('#example'),\n            showSelection: true\n          })\n        "),
  /*#__PURE__*/_createTextVNode("\n      ")
], -1)
const _hoisted_7 = { class: "section" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Disabled", -1)
const _hoisted_9 = { class: "row example" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { id: "exampleDisabled" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("        "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-javascript" }, "\n          new FPMoney({\n            container: document.querySelector('#example'),\n            disabled: true\n          })\n\n          // Or\n\n          var fp = new FPMoney({ container: document.querySelector('#example') })\n          fp.setDisabled(true)\n        "),
  /*#__PURE__*/_createTextVNode("\n      ")
], -1)
const _hoisted_12 = { class: "section" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Display Only", -1)
const _hoisted_14 = { class: "example row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { id: "exampleDisplayOnly" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("pre", null, [
  /*#__PURE__*/_createTextVNode("        "),
  /*#__PURE__*/_createElementVNode("code", { class: "language-javascript" }, "\n          new FPMoney({\n            container: document.querySelector('#example'),\n            displayOnly: true\n          })\n\n          // Or\n\n          var fp = new FPMoney({ container: document.querySelector('#example') })\n          fp.setDisplayOnly(true)\n        "),
  /*#__PURE__*/_createTextVNode("\n      ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"section\"><div class=\"header\">Min Value</div><div class=\"example row\"><div id=\"exampleMinValue\"></div></div><pre>        <code class=\"language-javascript\">\n          new FPMoney({\n            container: document.querySelector(&#39;#example&#39;),\n            minValue: 0 // only positive numbers allowed\n          })\n        </code>\n      </pre></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", null, _toDisplayString(_ctx.curSelectionValues), 1),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (_ctx.disabled)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleDisabled()))
            }, _toDisplayString(_ctx.disabled.disabled ? 'Enable': 'Disable'), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_11
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        (_ctx.disabled)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleDisplayOnly()))
            }, _toDisplayString(_ctx.displayOnly.displayOnly ? 'Enable': 'Disable'), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_16
    ]),
    _hoisted_17
  ]))
}